import React, { Component }     from 'react'
import BpmCounter               from '../../../utils/bpm_counter'
import ActivityIndicator        from './ActivityIndicator'
import RestingRateIndicator     from './RestingRateIndicator'
import { animateCSS }           from '../../../utils/animateCSS'
import ComponentHasTranslations from '../../../utils/component_has_translations'


class Tap extends Component {
  softResetAFter = 5 * 1000
  bpmCounter     = new BpmCounter
  default_bpm_bg   = 'gray'

  constructor(props) {
    super(props);
    this.state = { 
      count: undefined,
      rate_indicator_color: this.default_bpm_bg,
    }

    this.observeBpmCounter()
    this.setDocumentKeypressHandler()
  }

  observeBpmCounter() {
    this.bpmCounter.registerPropertyListener( 'count', 
      (old_count, count) => this.setState({ count: count })
    )
  }
  
  componentDidMount () {
    // make sure this shows at some point even if they don't click
    setTimeout(
      () => this.setHasInteracted(), 2000
    )
  }
  
  setDocumentKeypressHandler = () => {
    window.onkeydown = (e) => {
      //stop space bar from scrolling page
      //and count for get beat instead
      if(e.keyCode == 32 && e.target == document.body) { //space
        e.preventDefault()
        this.beat()
      } 
      //let <esc> make stale
      else if(e.keyCode == 27 && e.target == document.body) { 
        e.preventDefault()
        this.reset()
      }
    }
  }

  beat = () => {
    this.bpmCounter.beat()
    animateCSS('#tap-box', ['pulse', 'fastest'])
    this.queueSoftReset()
    if (this.bpmCounter.count > 5) this.setHasInteracted()
  }

  setHasInteracted = () => {
    if (!this.props.hasInteracted) this.props.setHasInteracted(true)
  }

  reset = () => {
    clearTimeout(this.softResetTimerId)
    this.bpmCounter.reset()
    animateCSS('#tap-box', ['flipInX', 'faster'])
    animateCSS('#bpm-num-cont', ['flipInX', 'faster'])
  }

  //resets bpmCounter without updating UI, making next beat a new calculation set
  queueSoftReset = () => {
    clearTimeout(this.softResetTimerId)
    this.softResetTimerId = setTimeout(this.bpmCounter.reset, this.softResetAFter )
  }

  setRateIndicatorColor = (color) => this.setState({rate_indicator_color: color || this.default_bpm_bg})

  get indicator() {
    return (
      {
        activity: <ActivityIndicator
          count={this.state.count}
          bpm={this.bpmCounter.bpm()}
          setRateIndicatorColor={this.setRateIndicatorColor}
          breakpoint={this.props.breakpoint }
          tr={this.props.tr}
        />,
        resting: <RestingRateIndicator 
          count={this.state.count}
          bpm={this.bpmCounter.bpm()}
          setRateIndicatorColor={this.setRateIndicatorColor}
          breakpoint={this.props.breakpoint }
          tr={this.props.tr}
        />
      }
    )
  }

  render = () => {
    return (
      <div className='tap-container'>
        { this.indicator[this.props.indicator_type] }

        <div id='controls' className='row'>
          <div className="col-8">
            <div id='tap-box' onClick={this.beat} >
              <div >
                <span 
                  className='tap-text'
                  dangerouslySetInnerHTML={{ __html: this.tr('tap') }} 
                />
                <br/>
                <span 
                  className='space'
                  dangerouslySetInnerHTML={{ __html: `[${this.tr('space_bar')}]` }} 
                />
              </div>
            </div>
            <span id='reset' onClick={this.reset}>{this.tr('reset')} [esc]</span>
          </div>

          <div className="col-4">
            <div id='bpm-num-cont' style={{backgroundColor: this.state.rate_indicator_color}}>

              <div>
                <div id='bpm-num' >
                  {this.bpmCounter.bpm().toFixed(0) || 0}
                </div>
                BPM
              </div>
            </div>
          </div>
        </div>

      </div>
    )
  }
}

Object.assign(Tap.prototype, ComponentHasTranslations)
export default Tap
